import { Injectable } from '@angular/core';
import {
  PageMetaTag,
  PageMetaTagsAdapter,
} from '../../../domain/adapters/page-meta-tags.adapter';
import { Meta, Title } from '@angular/platform-browser';

export interface DefaultPageMetaTags {
  title: string;
  metaTags: PageMetaTag[];
}

@Injectable({
  providedIn: 'root',
})
export class PageMetaTagsService implements PageMetaTagsAdapter {
  constructor(private titleService: Title, private metaService: Meta) {}

  updateTitle(title: string): void {
    this.titleService.setTitle(title);
  }

  updateTag(tag: { name: string; content: string }): void {
    this.metaService.updateTag(tag);
  }

  removeTag(name: string): void {
    this.metaService.removeTag(`name="${name}"`);
  }
}
